import React from "react";

export function GlassCard({ className = "", children, hoverable = false, ...rest }) {
  return (
    <div
      className={`glass rounded-3xl ${
        hoverable
          ? "transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/[0.07] hover:shadow-[0_20px_60px_-30px_rgba(79,70,229,0.5)]"
          : ""
      } ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
